import type { ComponentType } from 'react';
import styles from './DashboardEmptyState.module.css';

interface DashboardEmptyStateProps {
  /** Omit in a section too small to spare the vertical space for it. */
  icon?: ComponentType<{ size?: number; className?: string }>;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  /** 'row' keeps the icon beside a left-aligned title/description column
   *  instead of stacking everything centered — for a section too short to
   *  spare the vertical space the default stacked layout needs. */
  layout?: 'stacked' | 'row';
}

export function DashboardEmptyState({
  icon: Icon,
  title,
  description,
  action,
  layout = 'stacked',
}: DashboardEmptyStateProps) {
  if (layout === 'row') {
    return (
      <div className={styles.rowContainer}>
        {Icon && (
          <span className={styles.rowIconBox}>
            <Icon size={18} className={styles.icon} />
          </span>
        )}
        <div className={styles.rowText}>
          <p className={styles.rowTitle}>{title}</p>
          {description && (
            <p className={styles.rowDescription}>{description}</p>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {Icon && (
        <span className={styles.iconBox}>
          <Icon size={26} className={styles.icon} />
        </span>
      )}

      <p className={styles.title}>{title}</p>
      {description && <p className={styles.description}>{description}</p>}

      {action && (
        <button type="button" className={styles.action} onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
